import angular from "angular"
import "front-end-web-commons"
import "../../bower_components/front-end-web-commons/app/cancellation/commonsCancellationModule"
import "../../bower_components/front-end-web-commons/app/routingConfig/routingConfig"
import "../../bower_components/front-end-web-commons/app/violation/violation"

export default angular.module("cancellationModule", ["nodeCommandsModule", "commonsCancellationModule", "routingConfigModule", "violationModule"])